module.exports = __webpack_public_path__ + "static/media/ExamScience.1ef1e7e5.svg";